/** Canonical Weberlo brand teal — secondary actions, info, `--mui-palette-secondary-main` */
export const BRAND_ACCENT = '#2A9D8F' as const

/** Hover / lighter accent for contained secondary buttons */
export const BRAND_ACCENT_HOVER = '#4EBDB0' as const

/** Space-separated channels for MUI CSS var `--mui-palette-secondary-mainChannel` */
export const BRAND_ACCENT_MAIN_CHANNEL = '42 157 143' as const
